import { RootState } from '../../../../rootReducer';

export const availableCodesSelector = (state: RootState) => state.codeBankModuleReducer.AvailableCodesReducer;
